import { Suspense } from 'react'
import type { BlueprintNode } from 'src/types/queries'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import { ColumnValuesDatalist } from '@components/ColumnValuesDatalist/ ColumnValuesDatalist'

import './StringFilterValue.css'

interface StringFilterValueProps {
  blueprint: BlueprintNode
  column: string
  listId: string
  value: string | number | boolean | undefined
  placeholder?: string
  onChange: (value: string) => void
}

export const StringFilterValue = ({
  blueprint,
  column,
  listId,
  value,
  placeholder,
  onChange
}: StringFilterValueProps) => {
  const text = typeof value === 'string' ? value : ''

  return (
    <label className="string-filter">
      <input
        type="text"
        className="boundary-input"
        list={listId}
        value={text}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
      />
      <ErrorBoundary errorComponent={() => null}>
        <Suspense fallback={null}>
          <ColumnValuesDatalist
            blueprint={blueprint}
            column={column}
            id={listId}
            filter={text}
          />
        </Suspense>
      </ErrorBoundary>
    </label>
  )
}
